import React from 'react';
import pako from 'pako';
import { Buffer } from 'buffer'; // Remove 'node:' scheme
import value from './constant';

const decodeUnzip = (data: string): string => {
  const decodedData = Buffer.from(data, 'base64');
  const decodedByteArray = new Uint8Array(decodedData);
  const outData = pako
    .inflate(decodedByteArray, {
      to: 'string',
    })
    .replaceAll(new RegExp(', ', 'g'), ',');
  return JSON.parse(outData);
};

export { decodeUnzip };
